import React, { useContext, useEffect, useState } from "react"
import { Row, Col, FormGroup, Input, Button, Table } from "reactstrap"
import { DataContext } from "../../context/dataContext"
import FetchUpdatedProductsAPI from "../../common/config/fetch-updated-products"
import moment from "moment"
import FetchSingleProduct from "../../common/config/fetch-single-product"
import Loader from "../../components/Loader/loader"
import { useNavigate } from "react-router-dom"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import useValidation from "../../hooks/useValidation"
const FetchProducts = ({
  onFormDataChange,
  setTab,
  setSingleProductData,
  setSiteSubscribeKey,
  siteSubscribeKey,
  setFormData,
  selectedProduct,
  setSelectedProduct,
  formData,
}) => {
  const navigate = useNavigate()
  const { fetchAirports, airports, fetchSites, sites } = useContext(DataContext)
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(false)
  const [backstate, setBackState] = useState("quote-product")
  const { validate, errors, setErrors } = useValidation()

  useEffect(() => {
    fetchAirports()
    fetchSites()
  }, [])

  useEffect(() => {
    if (formData.dropOffDate) {
      const newPickUpDate = moment(formData.dropOffDate)
        .add(7, "days")
        .format("YYYY-MM-DD")
      setFormData(prev => ({ ...prev, pickUpDate: newPickUpDate }))
    }
  }, [formData.dropOffDate])

  const handleInputChange = ({ name, value }) => {
    const updatedFormData = { ...formData, [name]: value }
    const ErrorEmpty = { ...errors, [name]: "" }
    setErrors(ErrorEmpty)
    setFormData(updatedFormData)
    onFormDataChange(updatedFormData)

    if (name === "website") {
      const selectedSite = sites?.find(site => site?.id === parseInt(value))
      setSiteSubscribeKey(selectedSite ? selectedSite?.subscriber?.key : "")
    }
  }

  const handleFetchProducts = async e => {
    e.preventDefault()
    const validationErrors = validate(formData, "selection")
    if (!validationErrors) {
      return
    }
    setLoading(true)

    const params = {
      key: siteSubscribeKey,
      airport: formData?.airport,
      departure: moment(
        `${formData.dropOffDate} ${formData.dropOffTime}`
      ).format("DD-MM-YYYY HH:mm"),
      arrival: moment(`${formData.pickUpDate} ${formData.pickUpTime}`).format(
        "DD-MM-YYYY HH:mm"
      ),
      discount_code: formData?.promoCode,
      return_response: "",
    }
    try {
      const ProductsResponse = await FetchUpdatedProductsAPI(params)
      setProducts(ProductsResponse?.data)
      setBackState("products")
    } catch (error) {
      console.log("Error fetching products", error)
    } finally {
      setLoading(false)
    }
  }

  const handleSelectParking = product => {
    setSelectedProduct(product)
    setBackState("SelectedProducts")
  }

  const handleBookNow = async () => {
    setLoading(true)

    const params = {
      key: siteSubscribeKey,
      airport: formData?.airport,
      sku: selectedProduct?.sku,
      departure: moment(
        `${formData.dropOffDate} ${formData.dropOffTime}`
      ).format("DD-MM-YYYY HH:mm"),
      arrival: moment(`${formData.pickUpDate} ${formData.pickUpTime}`).format(
        "DD-MM-YYYY HH:mm"
      ),
      discount_code: formData?.promoCode,
      return_response: "",
    }
    try {
      const singleProductResponse = await FetchSingleProduct(params)
      if (singleProductResponse.response_code === 200) {
        setSingleProductData(singleProductResponse?.data)
        setTab("customer-vehicle-flight")
      }
    } catch (error) {
      console.log("Error fetching single product", error)
    } finally {
      setLoading(false)
    }
  }

  const handleBack = () => {
    if (backstate === "products") {
      setBackState("quote-product")
      setSelectedProduct(null)
    } else if (backstate === "quote-product") {
      navigate("/allbookings")
    } else if (backstate === "SelectedProducts") {
      setBackState("products")
      setSelectedProduct(null)
    }
  }
  {
    /* MATCHED Selected site for ADmin Charges*/
  }
  const matchedWebSite = sites.find(site => site.id == formData.website)

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {backstate === "quote-product" && (
            <Row>
              {/* Select Options */}
              <Row className="mb-3">
                <Col md={3}>
                  <FormGroup>
                    <label htmlFor="website" className="form-label">
                      Select Website: <span className="required">*</span>
                    </label>
                    <Input
                      type="select"
                      name="website"
                      id="website"
                      className="form-input"
                      invalid={errors.website}
                      value={formData.website}
                      onChange={e =>
                        handleInputChange({
                          name: "website",
                          value: e.target.value,
                        })
                      }
                      required
                    >
                      <option value="">Select Sites</option>
                      {sites?.map(site => (
                        <option key={site?.id} value={site?.id}>
                          {site?.name}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <label htmlFor="airport" className="form-label">
                      Select Airport: <span className="required">*</span>
                    </label>
                    <Input
                      type="select"
                      name="airport"
                      id="airport"
                      invalid={errors.airport}
                      className="form-input"
                      value={formData.airport}
                      onChange={e =>
                        handleInputChange({
                          name: "airport",
                          value: e.target.value,
                        })
                      }
                      required
                    >
                      <option value=""> Airport</option>
                      {airports?.map(airport => (
                        <option key={airport?.id} value={airport?.code}>
                          {airport?.name}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              {/*  Date Picker*/}

              <Row className="mb-3">
                <Col md={3}>
                  <FormGroup>
                    <label htmlFor="dropOffDate" className="form-label">
                      Drop-Off Date: <span className="required">*</span>
                    </label>

                    <DatePicker
                      selected={
                        formData?.dropOffDate
                          ? new Date(formData?.dropOffDate)
                          : null
                      }
                      onChange={date =>
                        handleInputChange({
                          name: "dropOffDate",
                          value: moment(date).format("YYYY-MM-DD"),
                        })
                      }
                      minDate={new Date()}
                      className="form-input"
                      dateFormat="dd-MM-yyyy"
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <label htmlFor="dropOffTime" className="form-label">
                      Drop-Off Time: <span className="required">*</span>
                    </label>
                    <DatePicker
                      selected={
                        formData.dropOffTime
                          ? new Date(`1970-01-01T${formData.dropOffTime}`)
                          : null
                      }
                      onChange={time =>
                        handleInputChange({
                          name: "dropOffTime",
                          value: time.toTimeString().slice(0, 5),
                        })
                      }
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeFormat="HH:mm"
                      dateFormat="HH:mm"
                      className="form-input"
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <label htmlFor="pickUpDate" className="form-label">
                      Pick-Up Date: <span className="required">*</span>
                    </label>
                    <DatePicker
                      selected={
                        formData?.pickUpDate
                          ? new Date(formData?.pickUpDate)
                          : null
                      }
                      onChange={date =>
                        handleInputChange({
                          name: "pickUpDate",
                          value: moment(date).format("YYYY-MM-DD"),
                        })
                      }
                      minDate={new Date()}
                      className="form-input"
                      dateFormat="dd-MM-yyyy"
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <label htmlFor="pickUpTime" className="form-label">
                      Pick-Up Time: <span className="required">*</span>
                    </label>
                    <DatePicker
                      selected={
                        formData.pickUpTime
                          ? new Date(`1970-01-01T${formData?.pickUpTime}`)
                          : null
                      }
                      onChange={time =>
                        handleInputChange({
                          name: "pickUpTime",
                          value: time.toTimeString().slice(0, 5),
                        })
                      }
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeFormat="HH:mm"
                      dateFormat="HH:mm"
                      className="form-input"
                      required
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <label htmlFor="promoCode" className="form-label">
                      Promo Code:
                    </label>
                    <Input
                      type="text"
                      name="promoCode"
                      id="promoCode"
                      className="form-input"
                      placeholder="Promo Code"
                      value={formData.promoCode}
                      onChange={e =>
                        handleInputChange({
                          name: "promoCode",
                          value: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>
              {/*  Back and Next*/}
              <Row className="mb-3">
                <Col md={6} className="d-flex align-items-end">
                  {backstate !== "quote-product" && (
                    <Button
                      color="secondary"
                      size="sm"
                      style={{ width: "100px" }}
                      onClick={handleBack}
                    >
                      Back
                    </Button>
                  )}
                </Col>

                <Col
                  md={6}
                  className="d-flex justify-content-end align-items-end"
                >
                  <Button
                    color="primary"
                    className="get-parking-btn"
                    size="sm"
                    onClick={handleFetchProducts}
                    style={{ width: "100px" }}
                  >
                    Next
                  </Button>
                </Col>
              </Row>
            </Row>
          )}
          {backstate === "products" &&
            products.length > 0 &&
            !selectedProduct && (
              <Row>
                <h4 className="mb-4">Companies</h4>
                <Table striped responsive>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Price</th>
                      <th>Discount</th>
                      <th>Booking Charges</th>
                      <th>TotalAmount</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products?.map(product => (
                      <tr key={product?.id}>
                        <td>{product?.name}</td>
                        <td>{product?.display_name}</td>
                        <td>£{product?.price_before_discount}</td>
                        <td>
                          £{product?.discount ? `${product.discount}` : "0.00"}
                        </td>
                        <td>
                          £
                          {product?.admin_charges
                            ? product?.admin_charges
                            : matchedWebSite?.admin_charge}
                        </td>
                        <td>
                          £
                          {(
                            Number(product?.price_before_discount || 0) -
                            Number(product?.discount || 0) +
                            Number(
                              product?.admin_charges
                                ? product?.admin_charges
                                : matchedWebSite?.admin_charge
                            )
                          ).toFixed(2)}
                        </td>

                        <td>
                          <Button
                            color="success"
                            size="sm"
                            onClick={() => handleSelectParking(product)}
                          >
                            Select Parking
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <Button
                  color="secondary"
                  size="sm"
                  style={{ width: "100px" }}
                  onClick={handleBack}
                >
                  Back
                </Button>
              </Row>
            )}
          {selectedProduct && (
            <div>
              <h5>Selected Product</h5>
              <Table striped responsive>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Price</th>
                    <th>Discount</th>
                    <th>Booking Charges</th>
                    <th>TotalAmount</th>

                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr key={selectedProduct?.id}>
                    <td>{selectedProduct?.name}</td>
                    <td>{selectedProduct?.display_name}</td>
                    <td>£{selectedProduct?.price_before_discount}</td>
                    <td>
                      £
                      {selectedProduct?.discount
                        ? `${selectedProduct.discount}`
                        : "0.00"}
                    </td>
                    <td>
                      £
                      {selectedProduct?.admin_charges
                        ? selectedProduct?.admin_charges
                        : matchedWebSite?.admin_charge}
                    </td>
                    <td>
                      £
                      {(
                        Number(selectedProduct?.price_before_discount || 0) -
                        Number(selectedProduct?.discount || 0) +
                        Number(
                          selectedProduct?.admin_charges
                            ? selectedProduct?.admin_charges
                            : matchedWebSite?.admin_charge
                        )
                      ).toFixed(2)}
                    </td>
                    <td>
                      <Button color="primary" size="sm" onClick={handleBookNow}>
                        Book Now
                      </Button>
                    </td>
                  </tr>
                </tbody>
              </Table>
              <Button
                color="secondary"
                size="sm"
                style={{ width: "100px" }}
                onClick={handleBack}
              >
                Back
              </Button>
            </div>
          )}
        </>
      )}
    </>
  )
}

export default FetchProducts
